/* eslint-disable react/prop-types */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import JSZip from 'jszip';
import { map } from 'lodash';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { SVG } from '@svgdotjs/svg.js';
import { PulseLoader } from 'react-spinners';
import text from '../../../text';
import { client } from '../../../utilities/api';
import { downloadFile } from '../../../utilities/files';
import mapScreenshotUtils from '../../../utilities/mapScreenshot';
import { GEOSPATIAL_FILES } from '../constants';
import { MapViewContext } from '../mapViewContext';
import classNames from 'classnames';
import { captureError } from '../../../utilities/error';
var toFileNameSafe = function(s) {
    return s.replace(/[^a-z0-9]/gi, '_').toLowerCase();
};
var DOWNLOAD_NOTIF_TIMEOUT = 2000; // 2sec
var downloadStatuses = [
    text('downloaded'),
    'Error'
];
var DownloadsMenu = function(param) {
    var handleCloseMenu = param.handleCloseMenu, selections = param.selections, _param_closeOnSelect = param.closeOnSelect, closeOnSelect = _param_closeOnSelect === void 0 ? true : _param_closeOnSelect;
    var downloadClickedPool = useRef([]);
    var state = useContext(MapViewContext).state;
    var _useState = _sliced_to_array(useState(false), 2), isDownloadingScreenshot = _useState[0], setIsDownloadingScreenshot = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), donwloadScreenshotStatus = _useState1[0], setDownloadScreenshotStatus = _useState1[1];
    var _useState2 = _sliced_to_array(useState(map(GEOSPATIAL_FILES, function(row) {
        return _object_spread_props(_object_spread({}, row), {
            originalDisplayName: row.displayName,
            isLoading: false
        });
    })), 2), geoSpatialFiles = _useState2[0], setGeoSpatialFiles = _useState2[1];
    var handleIsMenuLoading = useCallback(function(menuDisplayName, loadingValue) {
        var isError = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        var isMenuInGeoSpatial = !!geoSpatialFiles.find(function(file) {
            return file.displayName === menuDisplayName;
        });
        var handleIsLoadingProp = function(state) {
            setGeoSpatialFiles(function(file) {
                var itemToUpdate = file.find(function(item) {
                    return item.displayName === menuDisplayName;
                });
                if (itemToUpdate) {
                    var _displayName = isError ? 'Error' : text('downloaded');
                    return file.map(function(_file) {
                        return _file.displayName === menuDisplayName ? _object_spread_props(_object_spread({}, _file), {
                            isLoading: state,
                            displayName: !state ? _displayName : _file.originalDisplayName
                        }) : _file;
                    });
                }
                return file;
            });
        };
        if (loadingValue) {
            isMenuInGeoSpatial && handleIsLoadingProp(true);
            downloadClickedPool.current = _to_consumable_array(downloadClickedPool.current).concat([
                menuDisplayName
            ]);
        } else {
            isMenuInGeoSpatial && handleIsLoadingProp(false);
            setTimeout(function() {
                setGeoSpatialFiles(function(file) {
                    return file.map(function(_file) {
                        return downloadStatuses.includes(_file.displayName) ? _object_spread_props(_object_spread({}, _file), {
                            displayName: _file.originalDisplayName
                        }) : _file;
                    });
                });
            }, DOWNLOAD_NOTIF_TIMEOUT);
            downloadClickedPool.current = downloadClickedPool.current.filter(function(p) {
                return p !== menuDisplayName;
            });
        }
    }, [
        geoSpatialFiles
    ]);
    // todo: run in worker thread
    var handleScreenshot = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, selection, mapDim, _ref, layerPaths, bboxXy, mapTilesXy, labelsXy, draw, group, downloadUrl, fileName, err, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (closeOnSelect && handleCloseMenu) {
                        handleCloseMenu();
                    }
                    setIsDownloadingScreenshot(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        ,
                        13
                    ]);
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        9,
                        10,
                        11
                    ]);
                    _iterator = selections[Symbol.iterator]();
                    _state.label = 3;
                case 3:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        8
                    ];
                    selection = _step.value;
                    mapDim = {
                        width: state.mapRef.current.offsetWidth,
                        height: state.mapRef.current.offsetHeight
                    };
                    return [
                        4,
                        mapScreenshotUtils.computeMapScreenshot(state.map, mapDim, selection, state.coverage)
                    ];
                case 4:
                    _ref = _state.sent(), layerPaths = _ref.layerPaths, bboxXy = _ref.bboxXy, mapTilesXy = _ref.mapTilesXy, labelsXy = _ref.labelsXy;
                    draw = SVG();
                    group = draw.group();
                    mapScreenshotUtils.createSvgPath(group, layerPaths, selection.category_name);
                    draw.width(bboxXy.xMax - bboxXy.xMin);
                    draw.height(bboxXy.yMax - bboxXy.yMin);
                    return [
                        4,
                        mapScreenshotUtils.drawMapScreenshot(draw, mapTilesXy, labelsXy)
                    ];
                case 5:
                    downloadUrl = _state.sent();
                    fileName = "".concat(mapScreenshotUtils.toValidFileStem(selection.name), ".jpg");
                    return [
                        4,
                        downloadFile(downloadUrl, fileName)
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        3
                    ];
                case 8:
                    return [
                        3,
                        11
                    ];
                case 9:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        11
                    ];
                case 10:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 11:
                    setDownloadScreenshotStatus(text('downloaded'));
                    return [
                        3,
                        13
                    ];
                case 12:
                    error = _state.sent();
                    setDownloadScreenshotStatus('Error');
                    return [
                        3,
                        13
                    ];
                case 13:
                    setIsDownloadingScreenshot(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        selections,
        closeOnSelect,
        handleCloseMenu,
        state.mapRef,
        state.map,
        state.coverage
    ]);
    var downloadGeospatialFile = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(jobId, selections, fileType, menuDisplayName) {
            var _error, promises, results, urls, names, error, zip, error1;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        handleIsMenuLoading(menuDisplayName, true);
                        _error = null;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            10,
                            ,
                            11
                        ]);
                        promises = selections.map(/*#__PURE__*/ function() {
                            var _ref = _async_to_generator(function(selection) {
                                var data, fileName;
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                client.getSelectionFeaturesFile(jobId, [
                                                    selection.id
                                                ], fileType)
                                            ];
                                        case 1:
                                            data = _state.sent().data;
                                            fileName = selection.name ? toFileNameSafe(selection.name) : selection.id;
                                            return [
                                                2,
                                                {
                                                    url: data,
                                                    name: "".concat(fileName, ".").concat(fileType)
                                                }
                                            ];
                                    }
                                });
                            });
                            return function(selection) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        return [
                            4,
                            Promise.all(promises)
                        ];
                    case 2:
                        results = _state.sent();
                        urls = results.map(function(result) {
                            return result.url;
                        });
                        names = results.map(function(result) {
                            return result.name;
                        });
                        if (!(urls.length === 1)) return [
                            3,
                            7
                        ];
                        _state.label = 3;
                    case 3:
                        _state.trys.push([
                            3,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            downloadFile(urls[0])
                        ];
                    case 4:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        _error = error;
                        captureError(new Error("Error in downloadGeospatialFile-->downloadFile: ".concat(error)));
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            3,
                            9
                        ];
                    case 7:
                        if (!(urls.length > 1)) return [
                            3,
                            9
                        ];
                        zip = new JSZip();
                        return [
                            4,
                            Promise.all(urls.map(/*#__PURE__*/ function() {
                                var _ref = _async_to_generator(function(url, i) {
                                    var res, blob;
                                    return _ts_generator(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    fetch(url)
                                                ];
                                            case 1:
                                                res = _state.sent();
                                                return [
                                                    4,
                                                    res.blob()
                                                ];
                                            case 2:
                                                blob = _state.sent();
                                                zip.file(names[i], blob, {
                                                    blob: true
                                                });
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(url, i) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    case 8:
                        _state.sent();
                        zip.generateAsync({
                            type: 'blob'
                        }).then(function(content) {
                            downloadFile(URL.createObjectURL(content), 'shapes.zip');
                        }).catch(function(error) {
                            _error = error;
                        });
                        _state.label = 9;
                    case 9:
                        return [
                            3,
                            11
                        ];
                    case 10:
                        error1 = _state.sent();
                        _error = error1;
                        captureError(new Error("Error in downloadGeospatialFile: ".concat(error1)));
                        return [
                            3,
                            11
                        ];
                    case 11:
                        handleIsMenuLoading(menuDisplayName, false, !!_error);
                        return [
                            2
                        ];
                }
            });
        });
        return function(jobId, selections, fileType, menuDisplayName) {
            return _ref.apply(this, arguments);
        };
    }(), [
        handleIsMenuLoading
    ]);
    useEffect(function() {
        var timer;
        if (!isDownloadingScreenshot && downloadStatuses.includes(donwloadScreenshotStatus)) {
            timer = setTimeout(function() {
                setDownloadScreenshotStatus(null);
            }, DOWNLOAD_NOTIF_TIMEOUT);
        }
        return function() {
            return clearTimeout(timer);
        };
    }, [
        isDownloadingScreenshot,
        donwloadScreenshotStatus
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "geospatial-downloads-menu"
    }, /*#__PURE__*/ React.createElement(Dropdown.Item, {
        onClick: handleScreenshot,
        disabled: isDownloadingScreenshot || donwloadScreenshotStatus
    }, isDownloadingScreenshot ? /*#__PURE__*/ React.createElement("div", {
        className: "text-center w-100"
    }, /*#__PURE__*/ React.createElement(PulseLoader, {
        size: 8
    })) : donwloadScreenshotStatus ? /*#__PURE__*/ React.createElement("div", {
        className: classNames('text-center w-100 text-center font-italic', {
            'font-weight-light green-1': donwloadScreenshotStatus === text('downloaded'),
            'color-red-1': donwloadScreenshotStatus === 'Error'
        })
    }, donwloadScreenshotStatus) : text('jpgScreenshot')), geoSpatialFiles.map(function(shapeFile, key) {
        var isDisabled = shapeFile.isLoading || shapeFile.displayName === text('downloaded');
        return /*#__PURE__*/ React.createElement(Dropdown.Item, {
            key: key,
            onClick: /*#__PURE__*/ _async_to_generator(function() {
                var _state_job;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (closeOnSelect && handleCloseMenu) {
                                handleCloseMenu();
                            }
                            if (!selections || selections.length === 0) {
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                downloadGeospatialFile((_state_job = state.job) === null || _state_job === void 0 ? void 0 : _state_job.id, selections, shapeFile.fileExtension, shapeFile.displayName)
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }),
            disabled: isDisabled
        }, /*#__PURE__*/ React.createElement("div", {
            className: "position-relative w-100",
            style: {
                pointerEvents: 'none'
            }
        }, /*#__PURE__*/ React.createElement("div", {
            className: classNames('text-center w-100 h-100 position-absolute', {
                invisible: !shapeFile.isLoading
            })
        }, /*#__PURE__*/ React.createElement(PulseLoader, {
            size: 8
        })), /*#__PURE__*/ React.createElement("p", {
            className: classNames('mb-0', {
                invisible: shapeFile.isLoading || downloadStatuses.includes(text(shapeFile.displayName))
            })
        }, shapeFile.originalDisplayName), /*#__PURE__*/ React.createElement("p", {
            style: {
                top: 0
            },
            className: classNames('text-center w-100 h-100 position-absolute mb-0 font-italic', {
                invisible: !downloadStatuses.includes(shapeFile.displayName),
                'green-1 font-weight-light': shapeFile.displayName === text('downloaded'),
                'color-red-1': shapeFile.displayName === 'Error'
            })
        }, shapeFile.displayName)));
    }));
};
export default DownloadsMenu;
